var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",on:{"click":_vm.getBoxs}},[_c('img',{staticClass:"newBanner",attrs:{"src":"/static/img/newBanner.png","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }